import { useQuery, useMutation } from '@tanstack/react-query';
import { QRCodeStorageService } from '@/services/qr-code/QRCodeStorageService';
import { SavedQRCode } from '@/types/qr-code/saved-qr-code';

export const useSavedQRCodes = (agentId?: string) => {
  const queryKey = ['saved-qr-codes', agentId];

  const query = useQuery({
    queryKey,
    queryFn: () => QRCodeStorageService.getSavedQRCodes(agentId),
  });

  return {
    qrCodes: query.data || [],
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  };
};

export const useQRCodeRedownload = () => {
  return useMutation({
    mutationFn: (qrCode: SavedQRCode) =>
      QRCodeStorageService.redownloadQRCode(qrCode),
  });
};

export const useQRCodeDelete = () => {
  return useMutation({
    mutationFn: (qrCodeId: string) =>
      QRCodeStorageService.deleteSavedQRCode(qrCodeId),
  });
};
